<script>
export default {
  name: "Preview",
  props: {
    item: { type: Object, required: true },
    width: { type: String, default: "200px" },
    height: { type: String, default: "200px" },
  },
  computed: {
    isPDF() {
      return this.item.content_type === "application/pdf";
    },
  },
};
</script>

<template>
  <div>
    <img
      :src="item.file"
      :title="item.name"
      :width="width"
      :height="height"
      v-if="!isPDF"
    />

    <iframe
      :src="item.file"
      v-if="isPDF"
      :width="width"
      :height="height"
    ></iframe>
  </div>
</template>

<style scoped></style>
